import { CycleWithRels } from '@statsbomb/parachute-types';
import { atom } from 'jotai';
import { atomWithSuspenseQuery } from 'jotai-tanstack-query';
import { comparisonIdAtom } from '@/atoms/queryParams';
import { sortCyclesBySeasonAndComp } from '@/utils/cycles';
import { objSnakeToCamel } from '@/utils/queries';
import { fetchClientAtom } from '../client';

const rawComparisonTeamCyclesAtom = atomWithSuspenseQuery(get => {
  const { fetch } = get(fetchClientAtom);
  const queryKey = ['comparisonTeamCycles', get(comparisonIdAtom)] as const;

  const queryFn = async ({ queryKey: [, comparisonId] }: { queryKey: typeof queryKey }) => {
    if (!comparisonId) return [] as CycleWithRels[];
    return (await fetch(`/team/${comparisonId}/cycles`)) as CycleWithRels[];
  };

  return { queryKey, queryFn };
});

export const comparisonTeamCyclesAtom = atom(async get => {
  const rawCycles = await get(rawComparisonTeamCyclesAtom);
  return rawCycles.data.map(objSnakeToCamel);
});

export const comparisonTeamCyclesOrderedAtom = atom(async get => {
  const cycles = await get(comparisonTeamCyclesAtom);
  return sortCyclesBySeasonAndComp(cycles);
});

export const comparisonTeamDefaultCycleAtom = atom(async get => {
  const cycles = await get(comparisonTeamCyclesOrderedAtom);
  return cycles[0] ?? null;
});
